
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pdp-v2",
      function () {
        return require("private-next-pages/products/pdp-v2.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/pdp-v2"])
      });
    }
  